// src/pages/VideoStreams/videoStreamsApi.js
// Самодостаточный клиент админки видеопотоков (fetch напрямую).
// Без ?? и ?. — старый Babel в этом проекте их не парсит.
// ВЕРСИЯ С ОТЛАДОЧНЫМИ ЛОГАМИ — после диагностики их уберём.

import { API_VIDEO } from '../../config.js';

export class ApiError extends Error {
  constructor(status, body) {
    super('api_error');
    this.name = 'ApiError';
    this.status = status;
    this.body = body || null;
  }
}

const BASE = API_VIDEO;

const authHeaders = () => {
  let token = null;
  try {
    const user = JSON.parse(localStorage.getItem('ccAdmin.currentUser'));
    if (user && user.token) token = user.token;
  } catch (e) {
    /* пусто */
  }
  return token ? { Authorization: 'Bearer ' + token } : {};
};

const abs = (url) => {
  if (!url) return null;
  return url.indexOf('http') === 0 ? url : BASE + url;
};

const adaptRow = (it) => {
  const video = it.video
    ? {
        available: !!it.video.available,
        url: abs(it.video.url),
        file_name: it.video.file_name || null,
        mime_type: it.video.mime_type || null,
        duration_sec: it.video.duration_sec != null ? it.video.duration_sec : null,
      }
    : { available: false, url: null, file_name: null };

  return {
    id: it.id,
    source_name: it.source_name,
    source_name_kk: it.source_name_kk,
    address: it.address,
    address_kk: it.address_kk,
    location: it.location,
    location_kk: it.location_kk,
    plan_date: it.plan_date != null ? it.plan_date : null,
    fact_date: it.fact_date != null ? it.fact_date : null,
    video: video,
  };
};

export async function listVideoStreams() {
  const res = await fetch(BASE + '/api/video-streams/dashboard?date_kind=plan', {
    headers: Object.assign({ Accept: 'application/json' }, authHeaders()),
  });
  if (!res.ok) {
    throw new ApiError(res.status);
  }
  const data = await res.json();
  const d = data && data.data ? data.data : data || {};
  const items = d.items || [];
  return items.map(adaptRow);
}

// ДД.ММ.ГГГГ → ГГГГ-ММ-ДД. Если уже ISO или пусто — вернём как есть.
const toIso = (v) => {
  if (!v) return '';
  const s = String(v).trim();
  // уже ISO
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
  // ДД.ММ.ГГГГ
  const m = s.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
  if (m) return m[3] + '-' + m[2] + '-' + m[1];
  return s;
};

export async function createVideoStream(arg1, arg2) {
  // ====== ОТЛАДКА: смотрим, что реально пришло из формы ======
  console.log('=== CREATE VIDEO STREAM ===');
  console.log('arg1:', arg1);
  console.log('arg2:', arg2);
  console.log('arg1 is FormData:', typeof FormData !== 'undefined' && arg1 instanceof FormData);
  if (typeof FormData !== 'undefined' && arg1 instanceof FormData) {
    console.log('--- FormData entries ---');
    for (const pair of arg1.entries()) {
      console.log('FD:', pair[0], '=', pair[1]);
    }
  } else if (arg1 && typeof arg1 === 'object') {
    console.log('--- object keys ---', Object.keys(arg1));
    Object.keys(arg1).forEach((k) => console.log('OBJ:', k, '=', arg1[k]));
  }
  // ===========================================================

  const keys = ['source_name', 'address', 'location', 'plan_date', 'fact_date', 'duration_sec'];
  const dateKeys = { plan_date: 1, fact_date: 1 };
  const qs = new URLSearchParams();
  let file = null;

  const isFormData = typeof FormData !== 'undefined' && arg1 instanceof FormData;

  if (isFormData) {
    keys.forEach((k) => {
      let v = arg1.get(k);
      if (v !== null && v !== undefined && String(v).trim() !== '') {
        if (dateKeys[k]) v = toIso(v);
        qs.append(k, String(v).trim());
      }
    });
    file = arg1.get('video_file') || arg1.get('video') || arg1.get('file') || null;
  } else {
    const fields = arg1 || {};
    keys.forEach((k) => {
      let v = fields[k];
      if (v !== undefined && v !== null && String(v).trim() !== '') {
        if (dateKeys[k]) v = toIso(v);
        qs.append(k, String(v).trim());
      }
    });
    file = arg2 || null;
  }

  const url = BASE + '/api/video-streams?' + qs.toString();

  // ====== ОТЛАДКА: что уходит на бэк ======
  console.log('POST url:', url);
  console.log('query string:', qs.toString());
  console.log('file:', file);
  // ========================================

  const body = new FormData();
  if (file) body.append('video_file', file);

  const res = await fetch(url, {
    method: 'POST',
    headers: authHeaders(),
    body: body,
  });

  if (!res.ok) {
    let errBody = null;
    try {
      errBody = await res.json();
    } catch (e) {
      /* пусто */
    }
    console.log('CREATE failed:', res.status, errBody); // ОТЛАДКА
    throw new ApiError(res.status, errBody);
  }

  try {
    return adaptRow(await res.json());
  } catch (e) {
    return null;
  }
}
